import { render, staticRenderFns } from "./q3.vue?vue&type=template&id=40c59f98&scoped=true"
import script from "./q3.vue?vue&type=script&lang=js"
export * from "./q3.vue?vue&type=script&lang=js"
import style0 from "./q3.vue?vue&type=style&index=0&id=40c59f98&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c59f98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\new-tis\\FR-TISSOT-IFB-Discovery-SFCC\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40c59f98')) {
      api.createRecord('40c59f98', component.options)
    } else {
      api.reload('40c59f98', component.options)
    }
    module.hot.accept("./q3.vue?vue&type=template&id=40c59f98&scoped=true", function () {
      api.rerender('40c59f98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "cartridges/int_guidedProductFinder/cartridge/client/default/js/components/questionTemplates/q3.vue"
export default component.exports